import { AbstractDownloadableService } from "./abstract-downloadable.service";
import {
    Feedback
} from "../models";
import {mapGetToPostParams} from "../../app/helpers";

/**
 * @class FeedbackPmsApiService
 * @abstract
 * @extends {AbstractDownloadableService<Feedback>}
 */
export class FeedbackPmsApiService extends AbstractDownloadableService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/property/:propertyId/feedback(/:id)';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {Feedback}
     * @protected
     */
    newModel(attributes, ...params) {

        return new Feedback(attributes);
    }

    /**
     * @param {Object=} params
     * @param {Property=} property
     * @returns {Promise.<PaginationCollection<Feedback>>}
     */
    get(params = {}, property = null) {

        const url = this.url({propertyId: property ? property.id : 0});

        return this.http
            .get(url, {
                headers: this.authHeaders,
                params,
                ignoreLoadingBar: false
            })
            .then(this.getFeedbackCollector())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {Object=} params
     * @param {Property=} property
     * @returns {Promise.<PaginationCollection<Feedback>>}
     */
    grafDataByName(params = {}, property = null) {

        const url = this.url({propertyId: property ? property.id : 0}) + '/data-by-name';

        return this.http
            .get(url, {
                headers: this.authHeaders,
                params,
                ignoreLoadingBar: false
            })
            .then(this.getDataExtractor())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {Object=} params
     * @param {Property=} property
     * @returns {Promise.<PaginationCollection<Feedback>>}
     */
    trendValue(params = {}, property = null) {

        const url = this.url({propertyId: property ? property.id : 0}) + '/trend';

        return this.http
            .get(url, {
                headers: this.authHeaders,
                params,
                ignoreLoadingBar: false
            })
            .then(this.getDataExtractor())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {...*} params
     * @return {function(response: Object): PaginationCollection<M>}
     * @protected
     */
    getFeedbackCollector(...params) {

        return (response) => {

            const responseData = this.extractData(response);

            if (responseData.data && Array.isArray(responseData.data.data)) {

                return [{average:responseData.average},{pagination:this.newPaginationCollection(responseData.data, ...params)}];
            }
        };
    }

    /**
     * @param {string=} token
     * @param {Object=} params
     * @returns {Promise.<PaginationCollection<Feedback>>}
     */
    checkDoubleFeedback(params = {}, token) {

        return this.http
            .get(this.url({}, '/feedback/check-feedback/' + token), {
                headers: this.authHeaders,
                params,
                ignoreLoadingBar: true
            })
            .then(this.getDataExtractor())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {Feedback} feedback
     * @param {string} propertyId
     * @returns {Promise.<Feedback>}
     */
    create(feedback, propertyId) {

        const url = this.url({
            propertyId: propertyId
        });

        return this.http
            .post(url, feedback, {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    exportPdf(params = {}, property = null) {

        const url = this.url({propertyId: property ? property.id : 0}) + '/export-pdf';

        return this.download(url, params, 'Feedback.pdf');
    }

    exportCsv(params = {}, property = null) {

        const url = this.url({propertyId: property ? property.id : 0}) + '/export-csv';

        return this.download(url, params, 'Feedback.csv');
    }

    exportExcel(params = {}, property = null) {

        const url = this.url({propertyId: property ? property.id : 0}) + '/export-excel';

        return this.download(url, params, 'Feedback.xls');
    }

    sendEmail(params = {}, property = null) {

        const url = this.url({propertyId: property ? property.id : 0}) + '/send-email';

        return this.http
            .post(url, mapGetToPostParams(params), {
                headers: this.authHeaders,
            })
            .then(this.getDataExtractor())
            .catch(this.getErrorHandler());
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/feedback.service.js